export interface GetStartedCardConfig {
  id: string;
  titleKey: string;
  descriptionKey: string;
  actionTextKey: string;
  route: string;
  iconType: 'events' | 'surveys' | 'gift' | 'news';
}

export const getStartedCards: GetStartedCardConfig[] = [
  {
    id: 'add-event',
    titleKey: 'getStarted.addEvent.title',
    descriptionKey: 'getStarted.addEvent.description',
    actionTextKey: 'getStarted.addEvent.action',
    route: '/event',
    iconType: 'events',
  },
  {
    id: 'create-survey',
    titleKey: 'getStarted.createSurvey.title',
    descriptionKey: 'getStarted.createSurvey.description',
    actionTextKey: 'getStarted.createSurvey.action',
    route: '/survey',
    iconType: 'surveys',
  },
  {
    id: 'add-gift-cards',
    titleKey: 'getStarted.addGiftCards.title',
    descriptionKey: 'getStarted.addGiftCards.description',
    actionTextKey: 'getStarted.addGiftCards.action',
    route: '/e-gift-card',
    iconType: 'gift',
  },
  {
    id: 'add-news',
    titleKey: 'getStarted.addNews.title',
    descriptionKey: 'getStarted.addNews.description',
    actionTextKey: 'getStarted.addNews.action',
    route: '/news',
    iconType: 'news',
  },
];

